import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import useDetectSize from '@hooks/useDetectSize';
import { Box, IconButton, Text } from '@components/common';
import SvgIcon from '@components/SvgIcon';
import { AuthSelectors } from '@redux/AuthRedux';
import history from '@utils/history';
import SupportModal from '@containers/account/SupportModal';
// import ZenChat from '@services/support';

const Wrapper = styled(Box)`
  height: ${props => (props.withAccessory ? '104px' : '88px')};
  position: relative;

  @media screen and (max-width: 767px) {
    border-bottom: ${props =>
      props.noBorder ? '0px' : '1px solid rgba(0, 0, 0, 0.1)'};
  }
`;

const LeftWrapper = styled(Box)`
  z-index: 1;
  position: absolute;
  left: 16px;
  height: ${props => (props.withAccessory ? '104px' : '88px')};
  @media screen and (max-width: 767px) {
    left: 32px;
    padding-bottom: ${props => (props.withAccessory ? '32px' : '0px')};
  }
`;

const RightWrapper = styled(Box)`
  z-index: 1;
  position: absolute;
  @media screen and (max-width: 767px) {
    right: 16px;
    padding-bottom: ${props => (props.withAccessory ? '32px' : '0px')};
  }

  right: 0px;
  height: ${props => (props.withAccessory ? '104px' : '88px')};
`;

function Header(props) {
  const [showSupportModal, setShowSupportModal] = useState(false);
  const isMobile = useDetectSize();

  const {
    renderLeft,
    isLoggedIn,
    match,
    title,
    noBorder,
    renderHeaderAccessory
  } = props;
  const hideAccount =
    match.path === '/account' ||
    match.path === '/property' ||
    match.path === '/request-property';

  const isLandingLogin =
    match.path === '/auth/' || match.path === '/auth/login';

  const handleOnClickAccount = () => {
    history.push('/account');
  };

  const handleOnClickSupport = () => {
    // ZenChat.showLiveChat();
    setShowSupportModal(true);
  };

  const renderRightButton = iconSize => {
    if (!isLoggedIn) {
      return null;
    }
    if (!hideAccount) {
      return (
        <IconButton
          flexDirection="row"
          alignItems="center"
          display="flex"
          mx={[3, 4]}
          width={iconSize}
          height={iconSize}
          onClick={handleOnClickAccount}
          name="my-account"
          title="Account"
          textProps={{
            display: ['none', 'block'],
            ml: 1
          }}
        />
      );
    }

    return null;
  };

  const renderMobileLayout = () => {
    return (
      <Wrapper
        flexDirection="column"
        display="flex"
        justifyContent="flex-end"
        px={4}
        noBorder={noBorder}
        withAccessory={!!renderHeaderAccessory}
      >
        <LeftWrapper
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          display="flex"
          withAccessory={!!renderHeaderAccessory}
        >
          {renderLeft && renderLeft()}
          {!renderLeft && !isLandingLogin && (
            <IconButton
              onClick={() => {
                history.push('/');
              }}
              title={title || 'The Minte'}
              name="minte-logo"
            />
          )}
        </LeftWrapper>

        {title && !hideAccount && !isLandingLogin && (
          <Box
            flex={1}
            flexDirection="column"
            display="flex"
            justifyContent="center"
          >
            <Text color="darkGold" textAlign="center">
              {title}
            </Text>
          </Box>
        )}

        <RightWrapper
          flexDirection="row"
          alignItems="center"
          display="flex"
          withAccessory={!!renderHeaderAccessory}
        >
          <IconButton
            flexDirection="row"
            alignItems="center"
            display="flex"
            mr={3}
            name="support"
            onClick={handleOnClickSupport}
          />
          {renderRightButton(32)}
        </RightWrapper>

        {renderHeaderAccessory && renderHeaderAccessory()}
        <SupportModal
          link="https://spruce.page.link/GCQk"
          show={showSupportModal}
          dismiss={() => {
            setShowSupportModal(false);
          }}
        />
      </Wrapper>
    );
  };

  if (isMobile) {
    return renderMobileLayout();
  }

  return (
    <Wrapper flexDirection="row" display="flex" justifyContent="center" px={4}>
      <LeftWrapper flexDirection="row" alignItems="center" display="flex">
        {renderLeft ? renderLeft() : ''}
      </LeftWrapper>

      {!isLandingLogin && (
        <Box
          flexDirection="column"
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            history.push('/');
          }}
        >
          <SvgIcon name="minte-logo" width={32} height={32} />
          <Text ml={0} mt={2} color="darkGold">
            The Minte
          </Text>
        </Box>
      )}

      <RightWrapper flexDirection="row" alignItems="center" display="flex">
        <IconButton
          flexDirection="row"
          alignItems="center"
          display="flex"
          mr={4}
          width={16}
          height={16}
          name="support"
          title="Support"
          textProps={{
            display: ['none', 'block'],
            ml: 1
          }}
          onClick={handleOnClickSupport}
        />
        {renderRightButton(16)}
      </RightWrapper>
      <SupportModal
        link="https://spruce.page.link/GCQk"
        show={showSupportModal}
        dismiss={() => {
          setShowSupportModal(false);
        }}
      />
    </Wrapper>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  renderLeft: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  renderHeaderAccessory: PropTypes.func,
  match: PropTypes.object,
  noBorder: PropTypes.bool
};

const mapStatesToProps = state => ({
  isLoggedIn: AuthSelectors.selectIsLoggedIn(state)
});

const mapDispatchToProps = dispatch => ({});

const connectedHeader = connect(
  mapStatesToProps,
  mapDispatchToProps
)(Header);

export default withRouter(connectedHeader);
